'use strict';

var React = require('react');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// tmp/pictograms/services/RentalCarStation.tsx
var SvgRentalCarStation = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { fill: "none", viewBox: "0 0 43 28", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement(
  "path",
  {
    d: "M8.476 21.056a.66.66 0 0 0-1.315.082v1.4l.006.106c.064.624.689.986 1.358.986h2.812l.111-.003c.662-.04 1.252-.437 1.252-1.089v-.864l-.005-.083a.66.66 0 0 0-.655-.577l-.083.005a.66.66 0 0 0-.577.655v.633l-.043.003H8.525l-.044-.003v-1.168l-.005-.083Zm18.41-18.678C25.017 2.125 22.682 2 19.878 2l-.49.001c-2.587.014-4.76.14-6.523.377l-.285.04-.076.003a1.922 1.922 0 0 0-1.403.775L7.012 9.454a1.199 1.199 0 0 0-.993-.526H4.2a1.2 1.2 0 0 0-1.2 1.2v.042a1.2 1.2 0 0 0 1.2 1.2h1.696v6.91l.004.122a1.92 1.92 0 0 0 1.633 1.776c4.113.614 12.132.764 16.246.764l.112-.002a11.638 11.638 0 0 1-.608-1.44c-3.878-.024-11.66-.167-15.538-.746a.48.48 0 0 1-.409-.475v-3.204a1.2 1.2 0 0 0 .33.091l2.56.324a1.076 1.076 0 0 0 1.211-1.068v-.163a1.2 1.2 0 0 0-1.049-1.19l-2.56-.324a1.091 1.091 0 0 0-.492.052V11.23l.006-.072a.48.48 0 0 1 .427-.405c3.967-.393 9.979-.393 14.033-.393h.792c.118-.21.197-.416.273-.617.107-.28.21-.552.416-.816-.444-.005-.889-.007-1.333-.007h-1.154c-3.641-.005-8.618-.01-11.9.28l3.385-5.183.04-.043a.494.494 0 0 1 .322-.119l.105-.008.313-.044c1.165-.156 2.528-.263 4.088-.318l.87-.026.91-.015c.31-.003.625-.005.948-.005l.48.001.468.004.91.015.87.026c1.701.06 3.167.181 4.397.362l.18.014a.48.48 0 0 1 .31.191l.31.483a11.605 11.605 0 0 1 1.553-.242l-.677-1.058-.094-.118a1.93 1.93 0 0 0-1.337-.697l-.077-.002-.283-.041ZM22.08 14.453c-.037.177-.08.38-.08.597 0 .216.043.42.08.597.082.39.137.653-.34.653h-7.48c-.695 0-1.26-.56-1.26-1.25s.565-1.25 1.26-1.25h7.48c.477 0 .422.264.34.653Z",
    clipRule: "evenodd"
  }
), /* @__PURE__ */ React__namespace.createElement(
  "path",
  {
    d: "M24.75 14c0-2.07.605-3.89 1.671-5.179C27.475 7.547 29.013 6.75 31 6.75c1.987 0 3.525.797 4.579 2.071 1.066 1.289 1.671 3.11 1.671 5.179 0 3.888-2.516 7.143-6.25 10.935-3.734-3.792-6.25-7.047-6.25-10.935ZM31 5.25c-2.431 0-4.394.994-5.735 2.615C23.936 9.472 23.25 11.651 23.25 14c0 4.767 3.244 8.554 7.22 12.53a.75.75 0 0 0 1.06 0c3.976-3.976 7.22-7.763 7.22-12.53 0-2.349-.686-4.528-2.015-6.135C35.394 6.244 33.43 5.25 31 5.25Zm0 12.25a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm2-3.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
    clipRule: "evenodd"
  }
));
var RentalCarStation_default = SvgRentalCarStation;

module.exports = RentalCarStation_default;
